import * as React from "react";
import MuiCheckbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import styled from "styled-components";
import {
  CheckboxUncheckedIcon,
  CheckboxCheckedIcon,
} from "Components/Shared/Icons";
import { Typography } from "@material-ui/core";
import { StyledFlex } from "Components/Shared/StyledComponents";

type Props = CheckboxProps & {
  label?: string;
};

const StyledWrapper = styled(StyledFlex)`
  margin-left: -${props => props.theme.spacing(1)}px;

  :not(.disabled) {
    cursor: pointer;

    * {
      cursor: pointer;
    }
  }

  .disabled {
    cursor: not-allowed;
  }
`;

export const Checkbox: React.FunctionComponent<Props> = props => {
  const { label, ...rest } = props;
  return (
    <StyledWrapper
      className={props.disabled ? "disabled" : ""}
      alignItems={"center"}
    >
      <MuiCheckbox
        {...rest}
        color={"primary"}
        icon={<CheckboxUncheckedIcon />}
        checkedIcon={<CheckboxCheckedIcon />}
      />
      {label && (
        <label htmlFor={props.id}>
          <Typography>{label}</Typography>
        </label>
      )}
    </StyledWrapper>
  );
};
